import React from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { 
  LayoutDashboard, 
  CreditCard, 
  FileText, 
  Menu,
  ListChecks,
  Wallet
} from 'lucide-react';

const navItems = [
  { path: '/dashboard', icon: LayoutDashboard, label: 'Dashboard' },
  { path: '/prioridades', icon: ListChecks, label: 'Prioridades' },
  { path: '/estado-resultados', icon: FileText, label: 'P&L' },
  { path: '/flujo-caja', icon: Wallet, label: 'Flujo' },
];

export const MobileNav = ({ onMenuClick }) => {
  const location = useLocation();
  
  return (
    <nav className="mobile-bottom-nav" data-testid="mobile-nav">
      {navItems.map((item) => {
        const isActive = location.pathname === item.path;
        return (
          <NavLink
            key={item.path}
            to={item.path}
            className={`mobile-nav-item ${isActive ? 'active' : ''}`}
            data-testid={`mobile-nav-${item.path.replace('/', '')}`}
          >
            <item.icon className="w-5 h-5" />
            <span className="text-xs mt-1">{item.label}</span>
          </NavLink>
        );
      })}
      <button 
        onClick={onMenuClick} 
        className="mobile-nav-item"
        data-testid="mobile-nav-menu"
      >
        <Menu className="w-5 h-5" />
        <span className="text-xs mt-1">Menú</span>
      </button>
    </nav>
  );
};
